import * as types from '../../action/actionTypes';
import initialState from '../initialState';

export default function ScheduleReportsReducer(state = initialState.ScheduleReports, action){
    switch (action.type) {
        case types.GET_SCHEDULES_RECURRENCE_LIST: return {
            ...state, 
            RecurrenceReportslist: action.payload.recurrenceDetails,
            ReportList: action.payload.reportDetails
         };
         case types.GET_SCHEDULES_MAIL_LIST: return {
            ...state, EmailReceipentlist: action.getResponse,
         };
         case types.SELECTED_REPORT_ID: return {
            ...state, ReportId: action.reportId,
         };
         default : return state; 
      } 

}